import { Capacitor } from "@capacitor/core";

const isNativeIOS = Capacitor.getPlatform() === "ios";

let capListener = null;
let lastTs = 0;

export function startNativeCompass(onHeading) {
  if (!isNativeIOS) return;
  if (typeof onHeading !== "function") return;
  if (capListener) return;

  const plugin = Capacitor.Plugins?.CompassNative;

  if (!plugin || typeof plugin.startHeading !== "function") {
    console.warn("❌ CompassNative NÃO registado no Bridge");
    return;
  }

  capListener = plugin.addListener("heading", (e) => {
    const h = e?.heading;
    const ts = e?.ts || Date.now();

    if (!Number.isFinite(h)) return;
    if (ts - lastTs < 50) return; // ~20Hz

    lastTs = ts;
    const norm = ((h % 360) + 360) % 360;

    // 👉 entrega direta
    onHeading(norm);

    // 👉 evento global Trekkin
    window.dispatchEvent(
      new CustomEvent("trekkin:native-heading", {
        detail: { heading: norm, ts },
      })
    );
  });

  plugin.startHeading();
  console.log("🧭 [iOS] bússola nativa iniciada");
}

export function stopNativeCompass() {
  if (!isNativeIOS) return;

  const plugin = Capacitor.Plugins?.CompassNative;
  plugin?.stopHeading?.();

  if (capListener) {
    capListener.remove();
    capListener = null;
  }

  lastTs = 0;
  console.log("🧭 [iOS] bússola nativa parada");
}